// TUT-544 — os grupos e as áreas: a lista com as áreas de cada grupo, o
// catálogo das dez áreas e a gravação (nome, pessoas e áreas). O convite com
// `groupIds` mora em `membros.ts`.
import { demoApi } from "../demo-data";
import type { AreaDeAcesso, AreaId, UserGroup } from "../types";
import { request } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

export const apiDosGrupos = {
  /** Os grupos do escritório, cada um com as áreas e as marcas que a tela usa para travar. */
  listarGrupos(): Promise<{ items: UserGroup[] }> {
    if (useDemoApi) return demoApi.userGroups();
    return request<{ items: UserGroup[] }>("/user-groups");
  },
  /** As dez áreas que um grupo pode ligar, na ordem do catálogo. */
  listarAreas(): Promise<{ items: AreaDeAcesso[] }> {
    if (useDemoApi) return demoApi.userGroupAreas();
    return request<{ items: AreaDeAcesso[] }>("/user-groups/areas");
  },
  criarGrupo(name: string): Promise<UserGroup> {
    if (useDemoApi) return demoApi.createUserGroup({ name });
    return request<UserGroup>("/user-groups", {
      method: "POST",
      body: JSON.stringify({ name }),
    });
  },
  /** Substitui o que vier: o nome, o conjunto de pessoas, o conjunto de áreas. */
  salvarGrupo(
    id: string,
    input: { name?: string; userIds?: string[]; areas?: AreaId[] },
  ): Promise<UserGroup> {
    if (useDemoApi) return demoApi.updateUserGroup(id, input);
    return request<UserGroup>(`/user-groups/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify(input),
    });
  },
  apagarGrupo(id: string): Promise<{ affectedRules: number }> {
    if (useDemoApi) return demoApi.deleteUserGroup(id);
    return request<{ affectedRules: number }>(`/user-groups/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  },
};
